import type { HTTPService } from "@soft-db/http";

export type WeeklyLimitSummary = {
	id: string;
	name: string;
	query: { query: string; version: number };
};

export type WeeklyLimitEntry = {
	weekdays: number[];
	from: number;
	to: number;
	value: number;
};

export type WeeklyLimit = {
	id: string;
	name: string;
	site: string;
	query: { query: string; version: number };
	entries: WeeklyLimitEntry[];
};

export type CreateWeeklyLimit = {
	name: string;
	query: { query: string; version: number };
	entries: WeeklyLimitEntry[];
};

export class WeeklyLimitApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return this._http.get<WeeklyLimit>(`weekly-limits/${id}`);
	}

	async fetchWeeklyLimits(site: string) {
		return this._http.get<WeeklyLimitSummary[]>(`sites/${site}/weekly-limits`);
	}

	async create(site: string, weeklyLimit: CreateWeeklyLimit) {
		return this._http.post<WeeklyLimit>(`sites/${site}/weekly-limits`, weeklyLimit);
	}

	async update(id: string, weeklyLimit: CreateWeeklyLimit) {
		return this._http.put<WeeklyLimit>(`weekly-limits/${id}`, weeklyLimit);
	}

	async delete(id: string) {
		return this._http.delete<WeeklyLimit>(`weekly-limits/${id}`);
	}
}
